import { useQuery } from "@tanstack/react-query";
import { instrumentsRepository } from "$root/functional-areas/instruments/repository";
import type { ReviewEntity } from "$root/pages/ReviewInstruments.const";

/** The review composition of `uuid`, and the user's classification of each instrument it holds. */
export function useReviewCompositionQueries(uuid: string, entity: ReviewEntity) {
	const composition = instrumentsRepository.reviewComposition.useQuery(uuid, entity);
	const tickers = composition.data?.composition?.map((entry) => entry.ticker).filter((ticker) => ticker != null) ?? [];
	const userInstruments = useQuery({
		...instrumentsRepository.userClassifications.getQueryConfig(tickers),
		enabled: composition.data != null,
	});
	return { composition, userInstruments };
}
